import { useEventListeners } from '../utils';

export default class BaseView {
	constructor(container) {
		this.container = container;
		this.components = [];

		({ addListener: this.addListener, removeAllListeners: this.removeAllListeners } = useEventListeners(this));
	}

	destroy() {
		this.components.forEach((component) => {
			if (typeof component.destroy !== 'function') {
				return;
			}

			component.destroy();
		});

		this.removeAllListeners();
	}
}
